// extracted by mini-css-extract-plugin
export default {"box":"NRnTTVAjx978rhLlHSUr","generalInfoBox":"XB3ilOMCWv3QbWZ82xgB","chartBox":"KCW3JK8pQZPugkjKKA7y"};